import React from 'react';
import { Instagram, Twitter, Facebook } from '@mui/icons-material';
import { footerStyles as styles } from './footer.tailwind';
import mail from '../../../assets/svgs/mail.svg';
import phone from '../../../assets/svgs/phone.svg';
import { Link } from 'react-router-dom';
import data from './footer.data';
import routeConstant from '../../../lib/constants/routeConstant';
import { APP_LOGO_IMAGE } from '../../../lib/constants/globalConstant';

const Footer = () => {
  return (
    <footer className={styles.footer_wrpr}>
      <div className={`${styles.footer_container}`}>
        {/* 1st Section: Logo */}
        <Link to={routeConstant.DEFAULT_PAGE} className={styles.footer_logo}>
          <img src={APP_LOGO_IMAGE} alt="Logo" className={styles.footer_image} />
        </Link>

        {/* 2nd Section: Links */}
        <div className={`${styles.footer_sub_section}`}>
          {/* List and routeLinks are fetched fron .data.js file */}
          <ul className={styles.list_container}>
            <li className={styles.link_text}><Link to={routeConstant.LOGIN_PAGE} className={styles.hoverText}>Login</Link></li>
            <li className={styles.link_text}><Link to={routeConstant.SIGNUP_PAGE} className={styles.hoverText}>Sign Up</Link></li>
            <li className={`${styles.link_text}`}><a href="/#how-it-works" className={styles.hoverText}>How It Works</a></li>
          </ul>
        </div>

        {/* 3rd Section: Policies */}
        <div className={`${styles.footer_sub_section}`}>
          {/* List and routeLinks are fetched fron .data.js file */}
          <ul className={`${styles.list_container} screen-970:mt-0 sm:mt-10`}> {/* Explicitly added CSS for second-child */}
            <li className={styles.link_text}><Link to={routeConstant.TERMS} className={styles.hoverText}>Terms and Conditions</Link></li>
            <li className={styles.link_text}><Link to={routeConstant.PRIVACY} className={styles.hoverText}>Privacy Policy</Link></li>
            <li className={styles.link_text}><Link to={routeConstant.COOKIES} className={styles.hoverText}>Cookie Policy</Link></li>
          </ul>
        </div>

        {/* 4th Section: Contact Us */}
        <div>
          {/* Contact-Information and icons are fetched fron .data.js file */}
          <h4 className={styles.contact_us}>Contact Us</h4>
          <ul className={styles.list_container}>
            <li className={styles.list}>
              <img src={phone} alt="Phone" className={styles.contact_icon} />
              <a href={`tel:${data.Phone}`} className={styles.hoverText}>
                {data.Phone}
              </a>
            </li>
            <li className={styles.list}>
              <img src={mail} alt="Email" className={styles.contact_icon} />
              <a href={`mailto:${data.Mail}`} className={styles.hoverText}>{data.Mail}</a>
            </li>
          </ul>
          <div className={styles.icons}>
            <a href={`${data.Twitter}`} target="_blank" rel="noopener noreferrer" aria-label="Twitter" className={styles.hoverText}>
              <Twitter />
            </a>
            <a href={`${data.Facebook}`} target="_blank" rel="noopener noreferrer" aria-label="Facebook" className={styles.hoverText}>
              <Facebook />
            </a>
            <a href={`${data.Instagram}`} target="_blank" rel="noopener noreferrer" aria-label="Instagram" className={styles.hoverText}>
              <Instagram />
            </a>
          </div>
        </div>
      </div>

      {/* Bottom Divider */}
      <div className={styles.divider} />

      {/* Copyright and other-information */}
      <div className={styles.copyright}>
        &copy; {new Date().getFullYear()} {data.CompanyName}. All rights reserved.
      </div>
    </footer>
  );
};

export default Footer;
